import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
    uploadConfig: null
}


export const getUploadConfig = AsyncThunkAction('upload/config', API_BASE_URL + ApiURLs.Config.Upload)

const configSlice = createSlice({
    name: 'configuration',
    initialState: initialState,
    reducers: {
        setUploadConfig: (state, action) => {
            state.uploadConfig = action.payload.data
        }
    },
    extraReducers: (builder) => {
        // builder
        // .addCase(saveDocuments.pending, (state, action) => {
        //     // state.userInfo.status = RequestStatus.Pending;


        // }).addCase(saveDocuments.fulfilled, (state, action) => {
        //     if (action.payload.status == 200) {

        //     }
        //     if (action.payload.status == 500) {

        //     }
        // }).addCase(saveDocuments.rejected, (state, action) => {

        // })
    }
})

export const { setUploadConfig } = configSlice.actions;

export default configSlice.reducer